import { Link } from "react-router-dom";
import { Package, MapPin, RotateCcw, Shield, CreditCard, Truck } from "lucide-react";
import { WhatsAppIcon } from "@/components/ui/whatsapp-icon";
import { openCookieSettings } from "@/lib/consent";

export const Footer = () => {
  return (
    <footer className="bg-muted/50 border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">About SabiTradeNG</h3>
            <p className="text-muted-foreground text-sm mb-4">
              Your trusted WhatsApp commerce platform for seamless buying and selling in Nigeria.
            </p>
            <div className="flex items-center gap-2 text-whatsapp">
              <WhatsAppIcon className="h-5 w-5" size={20} />
              <span className="text-sm font-medium">WhatsApp Commerce Platform</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/sellers" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Sellers
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Categories
                </Link>
              </li>
              <li>
                <Link to="/track-order" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Browse Products
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Customer Service</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/help-center" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/shipping-info" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Returns
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Policies */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Legal & Policies</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © 2026 SabiTradeNG. All rights reserved. Powered by SABITRADENG BUSINESS SOLUTIONS
            </p>
            <div className="flex gap-6">
              <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms
              </Link>
              <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy
              </Link>
              <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Support
              </Link>
              <button
                type="button"
                onClick={openCookieSettings}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors text-left"
              >
                Cookie settings
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};